import { render, staticRenderFns } from "./BtnExcluirCronogramaDesembolsoParceiro.vue?vue&type=template&id=32f7e51f"
import script from "./BtnExcluirCronogramaDesembolsoParceiro.vue?vue&type=script&lang=js"
export * from "./BtnExcluirCronogramaDesembolsoParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports